import React from "react";
import { Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CustomSearch from "../CustomSearch/CustomSearch";
import FundsInlineDateRange from "./FundsInlineDateRange";
import FundsTableFilterActions from "./FundsTableFilterActions";

const sectionLabelSx = {
  color: "text.secondary",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  mb: 0.75,
  display: "block",
};

const FundsPageToolbar = ({
  searchValue,
  onSearchChange,
  onSearchClear,
  searchPlaceholder = "Search (Email, Full Name)",
  periodStartDate,
  periodEndDate,
  onPeriodStartChange,
  onPeriodEndChange,
  resetKey = 0,
  filterActionsProps,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", lg: "minmax(360px, 1fr) minmax(520px, auto)" },
      gap: { xs: 2, xl: 2.5 },
      alignItems: { xl: "flex-end" },
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
      <Typography sx={sectionLabelSx}>
        <SearchIcon sx={{ fontSize: 12, mr: 0.5, verticalAlign: "middle", mb: "2px" }} />
        Search & period
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.25,
          alignItems: "center",
        }}
      >
        <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: 200 } }}>
          <CustomSearch
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={onSearchChange}
            onClear={onSearchClear}
            style={{
              background: "#111",
              color: "#fff",
              borderColor: "rgba(255, 255, 255, 0.18)",
            }}
            sx={{ color: "rgba(255, 255, 255, 0.7)", cursor: "pointer" }}
            sx1={{ color: "#2AF598", opacity: 0.85 }}
          />
        </Box>
        <FundsInlineDateRange
          startDate={periodStartDate}
          endDate={periodEndDate}
          onStartDateChange={onPeriodStartChange}
          onEndDateChange={onPeriodEndChange}
          resetKey={resetKey}
        />
      </Box>
    </Box>

    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Typography sx={sectionLabelSx}>Table filters</Typography>
      <FundsTableFilterActions {...filterActionsProps} />
    </Box>
  </Box>
);

export default FundsPageToolbar;
